<ion-content>
  <div class="geolocalizingLoader">
    <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
    <div class="loader-text">
      {{ 'header.stateMessage.geolocalizing' | translate }}
    </div>
  </div>
</ion-content>
